import React, { useEffect, useState, useRef } from "react";
import EbgBannerImg from "../../assets/images/EbgBannerImg.png";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import styles from "../OurBussiness/InstitutionalBusiness.module.scss";
import aptechAssessmentLogo from "../../assets/images/aptech assessment.png";
import aptechTrainingLogo from "../../assets/images/training solution.png";
import aptechAssesmentEBG from "../../assets/images/AptechAssessmentEBG.png";
import aptechTrainingEBG from "../../assets/images/AptechTrainingEBG.png";
import aptechEICImg from "../../assets/images/aptechEICNew.png";
import { Icon } from "../../assets/Icons.tsx";
import EICLOGO from "../../assets/images/EIC LOGO.svg";
import { motion } from "framer-motion";
import MetaComponent from "../CommonComponents/MetaComponent.tsx";
import { useNavigate } from "react-router-dom";

const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Our Businesses", link: "/our-businesses" },
  { title: "Institutional Business", link: "/our-businesses" },
];
const InstitutionalBusiness: React.FC = () => {
  const content = [
    `The enterprise business of Aptech focuses on providing corporate and institutional clients with customised testing and assessment solutions, training services to corporates and educational institutions. The team works with leading private organisations, governments, and educational institutions to enhance workforce skills and assess their talent. <a href="/">Aptech</a> has been working in the institutional business over the past 15 years, across 190+ cities in India with the best-in-class quality and standards in assessments, testing, and training.`,
  ];
  const navigate = useNavigate();
  interface DataItem {
    src: string;
    imgAlt: string;
    imgTitle: string;
    title: string;
    description: string;
    srcLogo?: string;
    imgAltLogo: string;
    imgTitleLogo: string;
    contactPerson?: string;
    email?: string;
    url: string;
  }
  const data: DataItem[] = [
    {
      src: "/images/digital-checklist-review.jpg",
      imgAlt: "Person marking digital checklist on screen",
      imgTitle: "Digital Checklist Evaluation",
      title: "Aptech Assessment & Testing Solutions",
      description: `<p>Aptech offers comprehensive testing and assessment services for government, corporates and institutions to effectively measure competency and performance of employees in organisations. The assessments not only help professionals enhance their skills but also cre...</p>`,
      srcLogo: aptechAssessmentLogo,
      imgAltLogo: "Aptech Assessment & Testing Solutions",
      imgTitleLogo: "Aptech Assessment & Testing Solutions",
      url: "/our-businesses/institutional-business/aptech-assessment-and-testing",
    },
    {
      src: "/images/female-employee-computer-work.jpg",
      imgAlt: "Smiling woman working at desktop in office",
      imgTitle: "Smiling Professional Using Computer",
      title: "Aptech Training Solutions",
      description: `<p>Building a Skilled, Future-Ready India</p>
        <p>With a robust network of over 740+ centers and over 7.5 million learners trained, Aptech is a trusted partner for public institutions, educational bodies, and government agencies striving...</p>`,
      srcLogo: aptechTrainingLogo,
      imgAltLogo: "Aptech Training Solutions",
      imgTitleLogo: "Aptech Training Solutions",
      url: "/our-businesses/institutional-business/aptech-training-solutions",
    },
    {
      src: "/images/learning-materials-representing-education-success.jpg",
      imgAlt: "Books with graduation cap and globe on desk",
      imgTitle: "Learning Tools with Graduation Symbol",
      title: "Education Institutes and Corporates (EIC) Unit",
      srcLogo: EICLOGO,
      imgAltLogo: "Education Institutes and Corporates (EIC) Unit",
      imgTitleLogo: "Education Institutes and Corporates (EIC) Unit",
      description: `<strong>Creating Talent That's Trained, Future-Ready & Industry-Aligned</strong>
        <p classname="mb-0">With a legacy of over 38 years, a presence in 30+ countries, and over 7.5 million learners trained, Aptech is now reaching beyond its retail education model through EIC (Education Ins...</p>`,
      contactPerson: "",
      email: "reachus@aptech.co.in",
      url: "/our-businesses/institutional-business/eic",
    },
  ];
  const sectionRefs = useRef<(HTMLElement | null)[]>([]);
  const [hasAnimated, setHasAnimated] = useState<boolean[]>(
    data.map(() => false),
  );
  useEffect(() => {
    const observers = sectionRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          // Only animate if scrolling down and it hasn't animated before
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2, rootMargin: "0px 0px -50px 0px" }, // Ensures it's triggered when scrolling down
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [hasAnimated]);

  return (
    <div className={styles.institutionalBusiness}>
      <MetaComponent
        title="Corporate Training Solutions, Institutional Training Programs & Workforce Development | Aptech Limited"
        desc="Empower your organization with Aptech Limited’s corporate training solutions, institutional learning programs, and workforce development initiatives."
      />
      <BreadCrumb menu={breadcrumb} />
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className={`${styles.banner} section`}>
            <div className="row">
              <div className="col-12">
                <ImageTextSection
                  imageSrc={"/images/business-team-collaborating-at-cafe.png"}
                  imageAlt="Business Team Working Together On A Project At A Café Table"
                  imageTitle="Team Collaboration In A Modern Work Environment"
                  content={content}
                  colImageValue={5}
                  colTextValue={7}
                  heading="Aptech Institutional Business"
                  reverse={true}
                  imageAlign="center"
                  imageAlignInMob="center"
                  imageHeightTablet={`25rem`}
                  contentPosition={true}
                />
              </div>
            </div>
          </div>
        </motion.div>

        <div className={styles.EBGData}>
          {data.map((item, index) => {
            return (
              <motion.div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                initial={{ opacity: 0, y: 100 }}
                animate={hasAnimated[index] ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 1,
                  ease: "easeInOut",
                  delay: index * 0.2,
                }}
                className={`d-flex flex-column flex-md-row mb-5 gap-4`}
              >
                <img
                  src={item.src}
                  alt={item.imgAlt}
                  title={item.imgTitle ?? item.title}
                  className={`${styles.logoImage} `}
                />
                <div className="d-flex flex-column">
                  {item.srcLogo && (
                    <img
                      src={item.srcLogo}
                      alt={item.imgAltLogo}
                      title={item.imgTitleLogo ?? item.title}
                      style={{ width: "130px", height: "65px" }}
                    />
                  )}

                  <h6
                    className={`${styles.contentTitle} caps subHeading mb-2 `}
                  >
                    {item.title}
                  </h6>
                  <p
                    className={`${styles.contentDescription} para mb-0`}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></p>
                  <div>
                    <button
                      className={`secondary-btn`}
                      onClick={() => navigate(item.url)}
                    >
                      Know More
                    </button>
                  </div>
                  {(item.email || item.contactPerson) && (
                    <div className={styles.contactBox}>
                      {item.contactPerson && (
                        <p className={`para ${styles.contactPerson}`}>
                          Contact Person: {item.contactPerson}
                        </p>
                      )}
                      {item.email && (
                        <div className={styles.emailSection}>
                          <Icon name="emailIcon" />
                          <p className="para mb-0">
                            Email:{" "}
                            <a
                              style={{
                                textDecoration: "none",
                                color: "#036995",
                              }}
                              href={`mailto:${"reachus@aptech.co.in"}`}
                            >
                              reachus@aptech.co.in
                            </a>
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InstitutionalBusiness;
